module.exports = __webpack_public_path__ + "static/img/product_material_rd.9fcfe84.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/product_material_rd.png
// module id = goGZ
// module chunks = 0